import { useAppSelector } from '@/app/store/hooks';
import { useSignOutAfterPasswordChange } from '../hooks/useSignOutAfterPasswordChange';
import { selectPasswordChangeRequired } from '../../common/store/authSlice';
import { ChangePasswordDialog } from './ChangePasswordDialog';

/** Re-exported from its hook, where every own-password change now uses it (NB-552). */
export { PASSWORD_CHANGED_NOTICE } from '../hooks/useSignOutAfterPasswordChange';

/**
 * Change Password on first sign-in: the profile's dialog, mandatory, over whatever page the user landed on.
 *
 * Mounted once in the shell and opened by the session itself -- the access token's `pwd_chg` claim -- so it is
 * open on every page, after a refresh and after a typed URL alike, and absent for everybody who has already
 * chosen a password. None of this is the protection: the platform refuses every write but the change for the
 * same token, whatever the screen does.
 *
 * <p>Like every change of one's own password (NB-552), it ends at the sign-in page: the platform has ended every
 * session of the account, so the session is cleared here and the user signs in with the new password.
 */
export function FirstLoginPasswordDialog() {
  const required = useAppSelector(selectPasswordChangeRequired);
  const signOut = useSignOutAfterPasswordChange();

  if (!required) return null;

  const onChanged = () => {
    signOut();
    return undefined;
  };

  return <ChangePasswordDialog mandatory onChanged={onChanged} />;
}
